<template>
  <el-row class="ik-list-pagination" :gutter="0">
    <el-col :span="24" class="ik-list-pagination-group">
      <!-- 使用el-pagination组件替换自定义分页 -->
      <el-pagination
        class="pagination"
        :current-page="pageNoValue"
        :page-sizes="[5, 10, 20, 50, 100]"
        :page-size="pageSizeValue"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :hide-on-single-page="false"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-col>

    <!-- <el-col :span="6" class="ik-list-enterprise-info">
      <span style="float: left">{{ sysTitle }}</span>
    </el-col>

    <el-col :span="4" class="ik-list-data-info">
      <span style="float: right;margin-right: 20px">共{{ pageCountValue }}页，{{ totalCount }}条记录</span>
    </el-col> -->
  </el-row>
</template>

<script>
export default {
  name: 'IkPagination',
  props: {
    pageNo: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    totalCount: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      sysTitle: this.$store.getters['setting/getTitle'],
      // 分页参数
      pageNoValue: 1,
      pageSizeValue: 10,
      pageCountValue: 1
    }
  },
  watch: {
    // 传入参数同步 - 当前页
    pageNo: {
      handler(newVal, oldVal) {
        this.pageNoValue = newVal
      }
    },
    // 传入参数同步 - 页记录数
    pageSize: {
      handler(newVal, oldVal) {
        this.pageSizeValue = newVal
        this.pageCountValue = Math.ceil(this.totalCount / this.pageSizeValue)
      }
    },
    // 传入参数同步 - 总记录数
    totalCount: {
      handler(newVal, oldVal) {
        this.pageCountValue = Math.ceil(this.totalCount / this.pageSizeValue)
      }
    }
  },
  created() {
    this.pageSizeValue = this.pageSize
    this.pageNoValue = this.pageNo
    this.pageCountValue = Math.ceil(this.totalCount / this.pageSizeValue)
  },
  methods: {
    // 分页变更方法
    pageChange(pageNo, pageSize) {
      this.$emit('pageChangeMethod', pageNo, pageSize)
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.pageSizeValue = val
      this.pageNoValue = 1
      this.pageCountValue = Math.ceil(this.totalCount / this.pageSizeValue)
      this.pageChange(this.pageNoValue, this.pageSizeValue)
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.pageNoValue = val
      this.pageChange(this.pageNoValue, this.pageSizeValue)
    }
  }
}
</script>

<style scoped>
.ik-list-pagination {
  background-color: #ffffff;
  color: #000000;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content:flex-end
}

/* 分页信息 */
.ik-list-pagination-input {
  width: 120px;
  height: 32px;
  background-color: #ffffff;
  color: #000000;
}

.ik-list-pagination-pagesize {
  width: 70px;
  height: 32px;
}

/* 企业信息 */
.ik-list-enterprise-info {
  padding-left: 10px;
  font-size: 14px;
  line-height: 40px;
}

/* 记录信息 */
.ik-list-data-info {
  font-size: 14px;
  line-height: 40px;
}

/* 分页器样式 */
.pagination {
  text-align: right;
  height: 40px;
  padding: 4px 10px;
}

::v-deep .pagination .el-pagination__total {
  float: left;
  color: #000;
}

::v-deep .pagination .el-pagination__sizes {
  float: left;
  margin-left: 10px;
}

::v-deep .pagination .el-pagination__jump {
  color: #000;
}

::v-deep .pagination .el-input__inner {
  /* background-color: #1482f0; */
  border: 1px solid #1482f0;
  color: #000;
}

::v-deep .pagination .btn-prev {
  /* background-color: #1482f0; */
  color: #000;
}

::v-deep .pagination .btn-next {
  /* background-color: #1482f0; */
  color: #000;
}

::v-deep .pagination .el-pager li {
  border: 1px solid rgba(229, 230, 235, 1);
  background-color: rgb(255, 255, 255);
  color: #000;
  border-radius: 4px;
  margin: 0 4px;
}

::v-deep .pagination .el-pager li:hover {
  background-color: rgb(255, 255, 255);
  color: #000000;
}

::v-deep .pagination .el-pager li.active {
  background-color: #fff;
  color: #1482f0;
}
</style>
